import { render, staticRenderFns } from "./AppTextareaLegacy.vue?vue&type=template&id=0f8ad793&scoped=true"
import script from "./AppTextareaLegacy.vue?vue&type=script&lang=js"
export * from "./AppTextareaLegacy.vue?vue&type=script&lang=js"
import style0 from "./AppTextareaLegacy.vue?vue&type=style&index=0&id=0f8ad793&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8ad793",
  null
  
)

export default component.exports